import React, { FC, memo } from 'react'
import { OptionSelectorType } from './SearchSelector'

import styles from './SearchSelector.module.scss'

type Props = {
    option: OptionSelectorType
    onClick: (option: OptionSelectorType) => void
    upperCase?: boolean
}

const Option: FC<Props> = ({ option, upperCase, onClick }) => {
    return (
        <div className={styles.option} onClick={() => onClick(option)}>
            {upperCase ? option.value.toUpperCase() : option.value}
        </div>
    )
}

export default memo(Option)
